/**
 * The TrainLoop GitHub App's installation status as a chip. The customer's
 * Settings > GitHub App page and the staff Connections page render the same
 * status from /api/github-app, so both read one answer.
 */

import type { GithubAppStatusStatus } from '@/api/generated/model'
import { Badge } from '@/components/ui/badge'

export function GithubAppStatusBadge({ status }: { status: GithubAppStatusStatus }): React.JSX.Element {
  switch (status) {
    case 'installed':
      return <Badge variant="success">Installed</Badge>
    case 'not_connected':
      return <Badge variant="secondary">Not connected</Badge>
    case 'uninstalled':
      return <Badge variant="destructive">Not installed</Badge>
    case 'unavailable':
      return <Badge variant="warning">Unknown</Badge>
  }
}
